import { createAction, props } from '@ngrx/store';
import { ICnnMetaMaskState } from '../models/user.models';

export const metamaskConnected = createAction('[User] MetaMask Connected', props<{ user: ICnnMetaMaskState }>());
export const metamaskDisconnected = createAction('[User] MetaMask Disconnected');
